export * from './UiFrameSizeMaxIcon';
export * from './UiFrameSizeMaxIcon16Light';
export * from './UiFrameSizeMaxIcon16Regular';
export * from './UiFrameSizeMaxIcon16Solid';
export * from './UiFrameSizeMaxIcon20Light';
export * from './UiFrameSizeMaxIcon20Regular';
export * from './UiFrameSizeMaxIcon20Solid';
export * from './UiFrameSizeMaxIcon24Regular';
export * from './UiFrameSizeMaxIcon24Solid';
export * from './UiFrameSizeMaxIcon32Regular';
export * from './UiFrameSizeMaxIcon64Regular';
